import { Link } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { cn } from "@/lib/cn";

/** Jump back to the Apps launcher from MCE shells. */
export function AllAppsLink({ className }: { className?: string }) {
  return (
    <Link
      to="/apps"
      className={cn(
        "inline-flex h-10 items-center gap-1.5 rounded-lg border border-border px-3 text-sm font-semibold text-foreground hover:bg-muted",
        className,
      )}
      title="All Apps"
    >
      <LayoutGrid className="size-4" />
      <span className="hidden sm:inline">All Apps</span>
    </Link>
  );
}
